import styled from 'styled-components';
import { IC_EYE_HIDE, IC_EYE_SHOW } from '../../../Assets/images';

const InputFieldStyled = styled.div`
  width: 100%;

  .tooltip {
    z-index: 1;
    &.show {
      opacity: 1 !important;
    }
    .tooltip-arrow {
      transform: translateX(46px) !important;
      left: 9px !important;
      &:before {
        border-width: 8px 8px 0;
      }
    }
    .tooltip-inner {
      width: 100%;
      min-width: 380px;
      max-width: 388px;
      border-radius: 8px;
      padding: 15px 16px;
    }
  }

  .form-label {
    font-size: 16px;
    color: ${(props) => props.theme.text.medium};
    font-weight: 400 !important;
    padding-bottom: 25px;

    .subText {
      color: ${(props) => props.theme.text.medium};
      font-size: 14px;
      font-weight: 400 !important;
    }

    .info {
      display: inline-flex;
      position: relative;

      > div {
        width: 16px !important;
        height: 16px !important;
        top: 4px !important;
        cursor: pointer;
        position: relative !important;
      }
    }

    &.readOnly {
      font-size: 14px;
      color: ${(props) => props.theme.text.medium};
      margin: 0;
    }
  }

  .inputField {
    min-height: 40px !important;
    height: 44px;
    border-radius: 0px !important;
    border: none !important;
    border-bottom: 1px solid ${(props) => props.theme.color.border} !important;
    padding: 30px 8px 12px 4px !important;
    background: none;

    &:disabled ~ label {
      padding-left: 0px !important;
      opacity: 0.5;
    }

    & ~ label {
      padding-left: 0px !important;

      .info {
        display: none;
      }
    }

    &:not(:placeholder-shown) {
      & ~ label {
        transform: scale(0.85) translateY(-1.3rem) translateX(0.15rem);

        .form-label {
          font-size: 13px !important;
          font-weight: 600 !important;
        }

        .info {
          display: inline-flex;
        }
      }
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0;
      border-color: #1976d2 !important;

      & ~ label {
        transform: scale(0.85) translateY(-1.3rem) translateX(0.15rem);

        .form-label {
          font-size: 13px !important;
          font-weight: 600 !important;
        }

        .info {
          display: inline-flex;

          & > div {
            width: 16px !important;
            height: 16px !important;
            top: 4px !important;
          }
        }
      }
    }

    &.form-control-plaintext {
      height: auto;
      color: ${(props) => props.theme.text.dark};
      font-weight: 600;
      padding: 0;
      border: 0;

      &::placeholder {
        font-size: 0;
      }
    }
    &.is-invalid {
      background-image: none !important;
      border-color: ${(props) => props.theme.verification.red.main} !important;
    }

    &:disabled {
      border-color: ${(props) => props.theme.color.borderLight} !important;
    }
  }
  .textarea {
    min-height: 40px;
    max-height: 200px;
    border-radius: 0px !important;
    border: none !important;
    border-bottom: 1px solid ${(props) => props.theme.color.border} !important;
    resize: none;
    overflow: hidden;
    background: none;

    & ~ label {
      padding-left: 0px !important;
    }

    &:not(:placeholder-shown) {
      margin-top: 22px;
      padding-left: 4px;
      & ~ label {
        transform: scale(0.85) translateY(-1.3rem) translateX(0.15rem);

        .form-label {
          font-size: 13px !important;
          font-weight: 600 !important;
        }
      }
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0;
      border-color: #1976d2 !important;
      padding-left: 4px;
      margin-top: 22px;
      & ~ label {
        transform: scale(0.85) translateY(-1.3rem) translateX(0.15rem);

        .form-label {
          font-size: 13px !important;
          font-weight: 600 !important;
        }
      }
    }
    &.is-invalid {
      background-image: none !important;
      border-color: ${(props) => props.theme.verification.red.main};
    }
  }
  .invalid-feedback {
    font-size: 15px !important;
    font-weight: 600 !important;
    color: ${(props) => props.theme.verification.red.main};
    background: none !important;
    padding-left: 0 !important;
  }

  .password_icon {
    cursor: pointer;
    height: 58px;
    width: 58px;
    position: absolute;
    right: 0px;
    top: 0px;
    border: 0;
    background-repeat: no-repeat;
    background-position: right!important;
    background-size: 18px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;

    &.hide_eye_img {
      background: url(${IC_EYE_HIDE.src}) no-repeat;
    }

    &.show_eye_img {
      background: url(${IC_EYE_SHOW.src}) no-repeat;
    }
  }
`;

export default InputFieldStyled;